const getSubdomain = (env: string, ignore: string = '') => {
  if (env === ignore || env === '') {
    return ''
  } else {
    return `${env}.`
  }
}

export default getSubdomain
